import React from 'react';
import { IEarlyReturn } from '../../type/earlyReturn';
import useBgColorStore from '../../store/bgColor';

interface AllocationData {
  label: string;
  current: number;
  max: number;
}

interface AllocationsProps {
  title: string;
  data?: {
    busMax: {
      totalAllocatedPax: number;
      totalCapacity: number;
    };
    flightMax: {
      totalAllocatedPax: number;
      totalCapacity: number;
    };
    earlyReturn: IEarlyReturn;
  };
}

const Allocations: React.FC<AllocationsProps> = ({ title, data }) => {
  const { bgColor, updateBgColor } = useBgColorStore();
  if (!data) {
    // Handle the case where data is undefined
    return (
      <div className={`border  border-customBorder-border rounded-md bg-backgroundColor-white p-4 w-full mb-4`}>
        <h3 className="text-blue-700 font-semibold text-sm mb-2 text-start">
          {title}
        </h3>
        <p className="text-textColorGray text-sm">No allocation data available.</p>
      </div>
    );
  }

  // Transform the data to match the expected structure
  const formattedData: AllocationData[] = [
    {
      label: 'Bus Max',
      current: data.busMax.totalAllocatedPax,
      max: data.busMax.totalCapacity,
    },
    {
      label: 'Flight Max',
      current: data.flightMax.totalAllocatedPax,
      max: data.flightMax.totalCapacity,
    },
    {
      label: 'Early Return',
      current: data.earlyReturn.booked,
      max: data.earlyReturn.maximum,
    },
  ];

  return (
    <div className={`bg-backgroundColor-white border  border-customBorder-border rounded-md p-4 w-full mb-4`}>
      <h3 className="text-text-primary font-semibold text-sm mb-2 text-start">
        {title}
      </h3>
      <div className="mb-2"></div>
      <div className="flex justify-around">
        {formattedData.map((item, index) => (
          <div key={index} className="text-center">
            <p className="text-text-primary text-sm">{item.label}</p>
            <p className="font-semibold text-textColor text-base">
              <span className="text-textColor">{item.current}</span>/{item.max}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Allocations;
